import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { MatterFileType } from '@models/matter';
import { FriendlyGroupTypes } from '@models/documents';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { BusinessDocumentTemplatesService } from '@repos/document-templates/business-document-templates.service';
import { NavigationService } from '@services/nav/nav.service';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { ManageTemplatesContactAdminsComponent } from '../manage-templates-contact-admins/manage-templates-contact-admins.component';
import { NewDocumentFilteringFn } from '../new-document-dialog';
import { BusinessDocumentV2, DocumentV2 } from '@models/documents';
import { BusinessDocumentsState } from '@state/business/documents';
import { DocumentService } from 'src/app/shared/services/document/document.service';

@UntilDestroy()
@Component({
	selector: 'app-template-sidebar',
	templateUrl: './template-sidebar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TemplateSidebarComponent implements OnInit {
	public ICON = ICON;
	public searchText = '';
	public friendlyGroupTypes = FriendlyGroupTypes;
	businessDocuments: DocumentV2[];

	@SelectSnapshot(BusinessUsersState.isLoggedInUserAdmin)
	isLoggedInUserAdmin: boolean;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@SelectSnapshot(SelectedMatter.matterFileType) fileType: MatterFileType;
	@Select(BusinessDocumentsState.getAll) getAllBusinessDocuments$: Observable<
		BusinessDocumentV2[]
	>;
	@Select(BusinessDocumentsState.getAll) businessDocuments$: Observable<
		BusinessDocumentV2[]
	>;

	@Input() folderId: string;
	@Output() createDocumentFromTemplate = new EventEmitter<BusinessDocumentV2>();

	error = false;
	selectedDocuments: { [id: string]: DocumentV2 } = {};
	createNewSelected = false;
	newDocumentName: string;
	selectADocumentMessage = false;
	documentFilter: string;
	filteredBusinessDocuments: DocumentV2[] = [];
	creating = false;
	preFiterFn!: NewDocumentFilteringFn;

	constructor(
		private businessDocumentTemplatesService: BusinessDocumentTemplatesService,
		private matDialog: MatDialog,
		private navigationService: NavigationService,
		private cdr: ChangeDetectorRef,
		private docService: DocumentService,
	) {}

	ngOnInit(): void {
		this.docService
			.filterAvailableTemplates(
				this.businessDocuments$,
				this.fileType,
				this.preFiterFn,
			)
			.pipe(untilDestroyed(this))
			.subscribe((documents) => {
				this.businessDocuments = documents;
				this.filterDocuments();
			});
	}

	public onEndItemClick() {
		this.searchText = '';
	}

	filterDocuments() {
		if (this.documentFilter?.length > 0) {
			this.filteredBusinessDocuments = this.businessDocuments.filter(
				(x) =>
					x.title?.toLowerCase().includes(this.documentFilter?.toLowerCase()) ||
					x.groupType
						?.toLowerCase()
						.includes(this.documentFilter?.toLowerCase()),
			);
		} else {
			this.filteredBusinessDocuments = this.businessDocuments;
		}
		this.cdr.detectChanges();
	}

	createDocument(doc: BusinessDocumentV2) {
		this.createDocumentFromTemplate.emit(doc);
	}

	goToManageTemplates() {
		if (this.isLoggedInUserAdmin) {
			this.navigationService.goToBusinessManageTemplates(this.fileType);
		} else {
			this.matDialog.open(ManageTemplatesContactAdminsComponent);
		}
	}
}
